import { Controller } from "@hotwired/stimulus"

const CLIENT_PATH = /\/psychologist\/clients\/(\d+)/

// Prefills the client combobox when the psychologist is already on a client page.
export default class extends Controller {
  static targets = ["clientInput", "clientHidden"]
  static values = {
    clientOptionsUrl: String
  }

  connect() {
    if (this.hasClientHiddenTarget && this.clientHiddenTarget.value) return
    const match = window.location.pathname.match(CLIENT_PATH)
    if (!match || !this.hasClientOptionsUrlValue) return

    const url = new URL(this.clientOptionsUrlValue, window.location.origin)
    url.searchParams.set("id", match[1])
    fetch(url, { headers: { Accept: "application/json" } })
      .then((response) => (response.ok ? response.json() : null))
      .then((payload) => {
        const client = payload?.clients?.[0]
        if (!client || !this.hasClientHiddenTarget) return
        this.clientHiddenTarget.value = client.id
        if (this.hasClientInputTarget) this.clientInputTarget.value = client.label
      })
      .catch(() => {})
  }
}
